import MicroModal from "micromodal";
import { useState } from "react";

export const useModalHistoricAlert = () => {
  const [dataToStartCall, setDataToStartCall] = useState(null);

  const insertDataToStartCall = (data) => {
    setDataToStartCall(data);
  };
  const cleanDataToStartCall = () => {
    setDataToStartCall(null);
  };
  const openModal = (data) => {
    insertDataToStartCall(data);
    MicroModal.show("modal__historic-alert-modal");
  };
  const closeModal = () => {
    cleanDataToStartCall();
    MicroModal.close("modal__historic-alert-modal");
  };

  return {
    dataToStartCall,
    insertDataToStartCall,
    cleanDataToStartCall,
    openModal,
    closeModal,
  };
};
